import toFormat from "./toFormat";
import { getDefaultDateFormat, getDefaultDateFormatPattern, isIntlDefaultDateFormat } from "./defaultDateFormat";
import { language as destinationDefaultLanguage } from "src/../src-dynamic/destination.config";

function getRuntimeLocale(locale?: string): string {
  if (locale) return locale;
  if (destinationDefaultLanguage) return destinationDefaultLanguage;
  if (typeof navigator !== "undefined" && navigator.language) return navigator.language;
  return "en-US";
}

export default function toDefaultDateFormat(x: Date, locale?: string) {
  const runtimeLocale = getRuntimeLocale(locale);
  const defaultDateFormat = getDefaultDateFormat();
  if (isIntlDefaultDateFormat(defaultDateFormat)) {
    return new Intl.DateTimeFormat(runtimeLocale, { weekday: "short", month: "short", day: "numeric" }).format(x);
  }
  return toFormat(x, getDefaultDateFormatPattern(), runtimeLocale);
}
